<template>
  <BaseDialog
    v-model="showDialog"
    :title="title"
    :subtitle="subtitle"
    dialogIcon="mdi-message-text-outline"
    :btnActionName="btnActionName"
    @action="upload"
    @close="close"
  >
    <template v-slot>
      <v-form v-model="valid" ref="form">
        <v-checkbox
          v-if="updateFile"
          v-model="useOldName"
          label="Bruk filnavn fra dokumenthotell på opplastet dokument"
        ></v-checkbox>
        <v-textarea
          v-model="text"
          filled
          :label="textLabel"
          :rules="[(v) => !!v || 'Endringsmelding må være fylt ut!']"
          required
        ></v-textarea>
      </v-form>
    </template>
  </BaseDialog>
</template>

<script lang="ts">
import Vue from "vue";
import BaseDialog from "@/components/shared/dialog/BaseDialog.vue";

export default Vue.extend({
  props: {
    value: {
      type: Boolean,
      required: true,
    },
    title: {
      default: "",
    },
    subtitle: {
      default: "",
    },
    textLabel: {
      type: String,
      default: "Endringsmelding",
    },
    btnActionName: {
      type: String,
      default: "Last opp ny versjon",
    },
    updateFile: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      valid: true,
      text: "",
      useOldName: false,
    };
  },
  methods: {
    upload() {
      const valid = this.form.validate();
      if (valid) {
        this.$emit("upload", { text: this.text, useOldName: this.useOldName });
        this.form.reset();
      }
    },
    close() {
      this.$emit("close");
      this.showDialog = false;
      this.form.reset();
    },
  },

  computed: {
    showDialog: {
      get(): boolean {
        return this.value;
      },
      set(value: boolean) {
        this.$emit("input", value);
      },
    },
    form(): Vue & { validate: () => boolean; reset: () => boolean } {
      return this.$refs.form as Vue & {
        validate: () => boolean;
        reset: () => boolean;
      };
    },
  },
  components: {
    BaseDialog,
  },
});
</script>
